import PropTypes from "prop-types"
import "./style.scss"

function ExperimentError({ text }) {
  return <div className="components_experiment-error">
    <div className="error-description">{text}</div>
  </div>
}

ExperimentError.propTypes = {
  text: PropTypes.string.isRequired,
}

export default ExperimentError
